import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { ManageCompanyRouteParams } from '../manageCompanyNavConstants';
import { EpdLinks } from 'routes/EpdRoutes';
import CompanyOwnedToolsList from './tools-list/CompanyOwnedToolsList';
import CompanyOwnedTool from './tool/CompanyOwnedTool';

interface Props {
  companyId: string;
}

const CompanyOwnedTools: React.FC<Props> = ({ companyId }) => {
  const match = useRouteMatch<ManageCompanyRouteParams>(EpdLinks.manageCompanyTool(companyId, ':toolId?'));

  if (!match || !match.params.toolId) {
    return <CompanyOwnedToolsList companyId={companyId} />;
  }

  return <CompanyOwnedTool companyId={companyId} toolId={match.params.toolId} />;
};

export default CompanyOwnedTools;
